import PropTypes from "prop-types";
import { createPortal } from "react-dom";

import styles from "./SidePortal.module.css";

const SidePortal = ({ children, showContent, onClose }) => {
  return createPortal(
    <div className={`fixed top-0 right-0 w-full h-full z-[1000] transition-opacity duration-200 ${showContent ? "opacity-100" : "opacity-0 pointer-events-none"}`}>
      <button
        aria-label="Cerrar panel lateral"
        onClick={onClose}
        className="absolute inset-0 w-full h-full bg-black/50 cursor-default"
      />
      <div
        className={`w-[32rem] h-full bg-white absolute right-0 top-0 bottom-0 flex flex-col ${styles.contentWrapper} ${showContent ? styles.slideIn : styles.slideOut}`}
      >
        {!!showContent && <div className="flex-1 min-h-0 flex flex-col">{children}</div>}
      </div>
    </div>,
    document.body,
  );
};

SidePortal.propTypes = {
  children: PropTypes.node.isRequired,
  showContent: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SidePortal;
